export default __webpack_public_path__ + "static/media/instagram-comments.d71a8dc4.svg";